<template>
  <div>
    <div id="banner" style="float:left;">
      <el-carousel :interval="200000" arrow="none" :height="bannerHeight" class="banner-top">
        <el-carousel-item v-for="item in img_list" :key="item">
          <el-image :src="item" fit="cover" style="height: 100%;width:100%"></el-image>
        </el-carousel-item>
      </el-carousel>
    </div>
    <el-row class="home-center-box">
      <el-col :span="18" :offset="3" class="home-center" :xs="{span: 20, offset: 2}">
        <div  v-for="(value,i) in homeBottomLinksLeft" class="home-center-list" :key='i'>
          <el-link :underline="false"   class="home-bottom-a" @click="routerTo(value.url)">
          <dl class="home-bottom">
            <dt>
              <img :src="value.img" class="home-center-img"/>
            </dt>
            <dd>
                <p class="home-bottom-title">{{value.title}}</p>
                <span>{{value.englishTitle}}</span>
            </dd>
          </dl>
          </el-link>
        </div>
		<div  class="home-center-list">
			<el-link :underline="false"   class="home-bottom-a" v-popover:popover>
				<dl class="home-bottom">
					<dt>
						<img src="../assets/images/ab3.png" class="home-center-img"/>
					</dt>
					<dd>
						<p class="home-bottom-title">Wechat</p>
						<span>Gangxin Wechat</span>
					</dd>
				</dl>
            </el-link>
			<el-popover
				placement="top-start"
				width="150"
				trigger="click"
				ref="popover"
				:visible-arrow="false">
				<img
					style="width: 150px; height: 150px"
					src="../assets/images/small_wei.png">
			</el-popover>
        </div>
		<div  v-for="(value,i) in homeBottomLinksRight" class="home-center-list" :key='i'>
          <el-link :underline="false"   class="home-bottom-a" @click="routerTo(value.url)">
          <dl class="home-bottom">
            <dt>
              <img :src="value.img" class="home-center-img"/>
            </dt>
            <dd>
                <p class="home-bottom-title">{{value.title}}</p>
                <span>{{value.englishTitle}}</span>
            </dd>
          </dl>
          </el-link>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="40" class="home-center-box">
      <el-col :span="18" :offset="3" class="home-center home-center-news" :xs="{span: 22, offset: 1}">
        <el-row :gutter="20" >
          <el-col :span="9" :offset="2" :xs="{span: 20, offset: 2}" class="mobule-padding">
            <el-row class="companyNew-top">
            <el-col :span="24">
              <p class="newsClassName-right" style="border-bottom: 2px solid #a16e1e">Company Introduction</p>
              <a @click="routerTo('SinglePage_en?id=11&type=7&name=1')" style="cursor:pointer"><img src="../assets/images/ComIntroEn.jpg" class="companyNews-img"></a>
              </el-col>
            </el-row>
            <ul class="companyNew-ul">
              <li v-for="value in companyNews">
                <a  @click="routerTo('SinglePage_en?name=1&id=11&type=7&cid='+value.cid)" style="cursor:pointer">
                  <el-row>
                    <el-col :span="16" class="homt-news-list-title" :xs="{span: 16}">{{value.title}}</el-col>
                    <el-col :span="8" class="homt-news-list-title companyNew-date" :xs="{span: 8}">{{value.gmtCreate}}</el-col>
                  </el-row>
                </a>
              </li>
            </ul>
          </el-col>
          <el-col :span="9" :offset="2" :xs="{span: 20, offset: 2}" class="mobule-padding">
            <el-row class="companyNew-top">
              <el-col :span="24">
                <p class="newsClassName-right" style="border-bottom: 2px solid #a16e1e">Investor Education</p>
                <a @click="routerTo('SinglePage_en?name=2&id=63&type=3')" style="cursor:pointer"><img src="../assets/images/InvEduEn.jpg" class="companyNews-img"></a>
              </el-col>
            </el-row>
            <ul class="companyNew-ul">
              <li v-for="value in tradingNews">
                <a  @click="routerTo('SinglePage_en?name=1&id=63&type=3&cid='+value.cid)" style="cursor:pointer">
                  <el-row>
                    <el-col :span="16" class="homt-news-list-title" :xs="{span: 16}">{{value.title}}</el-col>
                    <el-col :span="8" class="homt-news-list-title companyNew-date" :xs="{span: 8}">{{value.gmtCreate}}</el-col>
                  </el-row>
                </a>
              </li>
            </ul>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <el-row :gutter="40" class="home-center-box" style="padding-bottom: 20px">
      <el-col :span="18" :offset="3" class="home-center home-center-news bottom-like" :xs="{span: 21, offset: 1}">
<!--        <p class="newsClassName-right" >友情链接：</p>-->
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="Supervisor" name="supervise">
            <div class="links-ul">
              <div class="links-li" v-for="value in friendshipLinks" v-if="value.type==1" >
                <a :href="value.link"  v-if="value.enName" target="_blank" >
                  <span>{{ value.enName }}</span>
                </a>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="Trade Center" name="transaction">
            <div class="links-ul">
              <div class="links-li" v-for="value in friendshipLinks" v-if="value.type==2">
                <a :href="value.link"  v-if="value.enName" target="_blank" >
                  <span>{{ value.enName }}</span>
                </a>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="Coorporate" name="cooperation">
            <div class="links-ul">
              <div class="links-li" v-for="value in friendshipLinks" v-if="value.type==3">
                <a :href="value.link"  v-if="value.enName" target="_blank" >
                  <span>{{ value.enName }}</span>
                </a>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  export default {
    name: "Home",
    data() {
      return {
        activeName: 'supervise',
        mWidth: 765,
        screenWidth: document.body.clientWidth,
        bannerHeight:'',
        img_list: [],
        homeBottomLinksLeft: [
          {
            title: 'Software',
            englishTitle: 'Multiple Software',
            img: require('../assets/images/ab2.png'),
            url:'#',
          },
		],
        homeBottomLinksRight: [
		  {
            title: 'Products',
            englishTitle: 'Trade Products',
            img: require('../assets/images/ab4.png'),
            url:'SinglePage_en?name=2&id=6363&type=1',
          },
        ],
        companyNews:[],
        friendshipLinks:[],
        tradingNews:[],
      };
    },
    methods: {
      handleClick(tab, event) {
        console.log(tab, event);
      },
      routerTo(value){
        this.$router.push(value)
      },

    },    computed:{
    },
    watch: {
      screenWidth (val) {
        this.screenWidth = val
        this.bannerHeight = (val * 200) / this.mWidth+ "px";
      },
      immediate: true, //immediate为true才会监听第一次绑定
    },
    mounted () {
      const that = this;
      window.onresize = function() {
        return function(){
          window.screenWidth = document.body.clientWidth;
          that.screenWidth = window.screenWidth
         }()
        }
        },
    created() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      if(flag){
		this.mWidth=400;
      } else { 
		this.mWidth=765; 
	  };
      this.bannerHeight = (this.screenWidth * 200) / this.mWidth+ "px";

      //banner
      this.$getAjax(this.$bannerListEn,{},(res)=>{
       for(let i in res.result){
         this.img_list.push(this.$baseURL+'/'+res.result[i].banner);
       }
      });

      // 友情链接
      this.$getAjax(this.$linkList,{},(res)=>{
          this.friendshipLinks=res.result;
      });

      //公司介绍
        this.$getAjax(this.$articleList,{typeId:'11',type:'en',categories:'2',size:'5',num:1},(res)=>{
          this.companyNews = res.rows;
		  for(let i in this.companyNews){
			  if(this.companyNews[i].gmtCreate != null){
			    var date = this.companyNews[i].gmtCreate.slice(5,10)+ "-" + this.companyNews[i].gmtCreate.slice(0,4);
				this.companyNews[i].gmtCreate = date;
			  }
		  }
        });
      //投资者教育
      this.$getAjax(this.$articleList,{typeId:'6363',type:'en',categories:'2',size:'5',num:1},(res)=>{
        this.tradingNews = res.rows;
		var value;
		for(value in this.tradingNews){
			  if(value != null && value.gmtCreate != null){
			    var date = value.gmtCreate.slice(5,10)+ "-" + value.gmtCreate.slice(0,4);
				value.gmtCreate = date;
			  }
		}
      });
    }

  }
</script>

<style scoped>
  .companyNew-ul{
    background: #fff;
    padding: 15px 0 15px 0;
    min-height: 189px;
  }
  .companyNews-img{
    float: left;
    margin-top: 10px;
    width: 100%;
    height: 137px;
    object-fit: cover;
  }
  #banner {
    width: 100%;
  }
  .newsClassName{
    font-size: 20px;
    line-height: 45px;
    font-weight: 600;
    color: #a16e1e;
    margin: 0;
  }
  .newsClassName-right{
    font-size: 20px;
    padding-bottom: 5px;
    font-weight: 600;
    color: #a16e1e;
    margin: 0;
  }
  .newsClassName-jydt{
    font-size: 20px;
    line-height: 45px;
    font-weight: 600;
    background: #fff;
    text-indent: 1em;
    border-bottom: 1px solid #f2f2f2;
    color: #a16e1e;
  }
  .companyNews-first{
    font-size: 18px;
    line-height: 40px;
    font-weight: 600;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .companyNews-first span{
    background: #dc1f1f;
    color: #fff;
    padding: 2px 12px;
    font-size: 14px;
    border-radius: 1px;
    margin-right: 10px;
  }
  .companyNew-ul,.tradingNews-ul{
    margin: 0;
  }
  .companyNew-ul li{
    line-height: 36px;
    text-align: left;
    font-size: 16px;
    background: url("../assets/images/yuandian_03.png") no-repeat  left;
    padding-left: 12px;
  }
  .tradingNews-ul li{
    background: #fff;
    margin-bottom: 11px;
    padding: 5px 9px;
  }
  .tradingNews-ul li:hover .tradingNews-content{
    color: #a16e1e;
  }
  .tradingNews-ul li:hover .tradingNews-title{
    color: #a16e1e;
  }
  .tradingNews-title{
    line-height: 34px;
    text-align: left;
    font-size: 16px;
    color:#666;
  }
  .homt-news-list-title{
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .companyNew-ul li a{
    width: 100%;
  }
  .companyNew-date{
    color: #c2c2c2;
    font-size: 13px;
    text-align: right;
    line-height: 40px;
  }
  .tradingNews-content{
    color: #666;
    font-size: 14px;
    text-align: right;
    margin-bottom: 5px;
  }

  .research-center-list li {
    line-height: 25px;
    background: url("../assets/images/jain.png") no-repeat left;
    padding-left: 10px;
  }

  .research-center-list li a {
    font-size: 12px;
  }

  .research-center-list li a:hover {
    color: #247bd8 !important;
  }

  .con-news-list li {
    width: 100%;
    font-size: 10px;
    line-height: 35px;
    border-bottom: rgb(204, 204, 204) 1px dashed;
    text-align: left;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    background: url("../assets/images/jain.png") no-repeat left;
  }

  .business-links li {
    width: 48%;
    float: left;
    margin-right: 2%;
    background-color: rgb(235, 234, 234);
    position: relative;
    margin-bottom: 8px;
    border-radius: 5px;
    height: 60px;
    line-height: 90px;
    font-size: 12px;
    color: #247bd8;
  }

  .business-links li a:visited {
    color: #247bd8;
  }

  .business-links li a {
    height: 100%;
    width: 100%;
    float: left;
  }

  .business-links li img {
    position: absolute;
    top: 7px;
    left: 40px
  }

  .business-links li:hover img {
    opacity: 1 !important;
  }

  .home-center {
    background-color: #fff;
    padding-top: 20px;
  }

  .home-center-box {
    background-color: #fff;
    margin: 0 !important;
  }

  .home-bottom, .home-bottom dt, .home-bottom dd {
    float: left;
  }
  .home-bottom dt{
    height: 60px;
    width: 60px;
  }

  .home-bottom dd {
    margin-left: 20px;
    margin-top: 5px;
  }

  .home-bottom-a span {
    font-size: 12px;
    color: #999;
    line-height: 22px;
  }

  .home-bottom-title {
    font-size: 15px;
    font-weight: 500;
    line-height: 22px;
    color: #333;
    margin: 10px 0 0 0;
    text-align: left;
  }

  .c_0100_3 {
    background: url("../assets/images/zbg4.jpg") no-repeat center center;
    background-size: cover;
    position: relative;
    background-attachment: fixed;
    text-align: center;
    height: 460px;
  }

  .mb {
    width: 100%;
    height: 100%;
    background: black;
    opacity: 0.4;
    position: absolute;
    left: 0;
    top: 0;
  }

  .wow {
    width: 100%;
    position: absolute;
    left: 0;
    top: 50%;
    margin-top: -77px;
    font-size: 36px;
    color: #fff;
    line-height: 42px;
    font-weight: 500;
  }

  .owo {
    font-size: 16px;
    color: #fff;
    line-height: 31px;
    font-style: oblique;
    width: 100%;
    position: absolute;
    left: 0;
    top: 50%;
    margin-top: -16px;
  }

  /*.home-news-top {*/
  /*  width: 100%;*/
  /*  float: left;*/
  /*  text-align: center;*/
  /*  position: relative;*/
  /*  margin-bottom: 30px;*/
  /*}*/

  /*.home-news-top span {*/
  /*  width: 310px;*/
  /*  line-height: 50px;*/
  /*  font-size: 36px;*/
  /*  padding-bottom: 32px;*/
  /*  border-bottom: solid 1px #cbaf61;*/
  /*  display: inline-block;*/
  /*  font-weight:bold;*/
  /*  color: #cbaf61;*/
  /*}*/

  /*.home-news-top svg {*/
  /*  display: block;*/
  /*  background: url("../assets/images/zico1.png") no-repeat center center;*/
  /*  width: 31px;*/
  /*  height: 27px;*/
  /*  position: absolute;*/
  /*  left: 50%;*/
  /*  bottom: -15px;*/
  /*  margin-left: -15px;*/
  /*  background-size: contain;*/
  /*}*/

  .home-news-ul,.links-ul {
    width: 100%;
    padding: 0;
    margin: 0;
  }
  .links-li{
    text-align: center;
    line-height: 35px;
    float: left;
    margin: 0 10px;
  }
  .links-li a{
    width: 100%;
  }
  .links-li-img{
    width: 100%;
  }
  .links-li-img:hover{
    transform: scale(1.2);
    transition: all 0.6s
  }
  .home-news-ul li{
    width: 100%;
    float: left;
    padding: 63px 10px 36px 10px;
    background: #FFFFFF;
    text-align: center;
    position: relative;
    overflow: hidden;
    margin-top: 1px;
  }
  .home-news-img{
    width: 100%;
    height: 286px;
    position: absolute;
    max-width: none;
    opacity: 0;
    z-index: 1;
    left: 0%;
    top: 0%;
  }
  .home-news-mb{
    width: 100%;
    height: 100%;
    background: black;
    left: 0;
    top: 0;
    position: absolute;
    opacity: 0;
    z-index: 2;
  }
  .home-news-ul .time{
    width: 100%;
    float: left;
    position: relative;
    z-index: 3;
  }
  .home-news-ul .time span{
    display: inline-block;
    width: 163px;
    height: 45px;
    line-height: 45px;
    background: #c6ab60;
    color: white;
    font-size: 14px;
  }
  .home-news-title{
    width: 100%;
    float: left;
    margin-top: 25px;
    font-size: 24px;
    line-height: 30px;
    position: relative;
    z-index: 3;
  }
  .elli{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .home-news-p{
    width: 100%;
    float: left;
    margin-top: 18px;
    font-size: 18px;
    color: #898989;
    line-height: 26px;
    position: relative;
    z-index: 3;
  }
  .home-news-span{
    width: 100%;
    float: left;
    margin-top: 11px;
    font-size: 12px;
    color: #a4a4a4;
    line-height: 26px;
    text-transform: uppercase;
    position: relative;
    z-index: 3;
  }
  .video-meun a{
    color: #a16e1e ;
    text-decoration: none;
    float: left;
    font-size: 14px;
    font-weight: 500;
    border: 1px solid #a16e1e;
    background: #fff;
    padding: 0 20px;
    border-radius: 10px;
    line-height: 35px;
    margin-top: 10px;
  }
  .video-meun a:hover{
    color: #fff !important;
    background: #a16e1e;
    font-weight: 500;
    transition: all .5s;
  }
  .video-meun a:visited{
  color: #a16e1e;
  }
  .home-news-span .span1{
    background:url("../assets/images/zico6_1.png") no-repeat left;
    margin: 0 17px;
    padding-left: 26px;
    background-size: contain;
    display: inline-block;
  }
  .home-news-span .span2{
    background:url("../assets/images/zico6_2.png") no-repeat left;
    margin: 0 17px;
    padding-left: 26px;
    background-size: contain;
    display: inline-block;
  }
  .home-news-ul li:hover .home-news-mb{
    opacity: 0.4 !important;
  }
  .home-news-ul li:hover .home-news-img{
    opacity: 1 !important;
  }
  .home-news-ul li:hover .elli{
    color: #fff;
  }
  .home-center-list{
    width: 33%;
    float: left;
    text-align: center;
  }
  .home-center-img{
    height: 60px;
    width: 60px;
  }
  .companyNew-top{
    border-bottom: 1px solid #e0e0e0;
    min-height: 160px;
    background: #fff;
  }
  .banner-top{
    margin-top: 0;
  }
  @media (max-width: 767px){
    .companyNew-top{
      min-height: 0px;
    }
    .tradingNews{
      padding: 0 !important;
      margin-top: 10px;
    }
    .home-news-span{
      width: 100%;
      float: left;
      margin-top: 6px;
      font-size: 12px;
      color: #a4a4a4;
      line-height: 26px;
      text-transform: uppercase;
      position: relative;
      z-index: 3;
    }
    .home-news-ul .time span{
      display: inline-block;
      width: 120px;
      height: 30px;
      line-height: 30px;
      background: #c6ab60;
      color: white;
      font-size: 14px;
    }
    .home-center-list{
      width: 33%;
      float: left;
      text-align: center;
    }
    .banner-top{
      margin-top: 0;
    }
    .home-center-img{
      height: 30px;
      width: 30px;
      margin: 7px 7px 0 0;
    }
    .home-bottom dd {
      margin-left: 0;
      margin-top: 0;
    }
    .home-bottom-title {
      font-size: 16px;
      font-weight: 500;
      line-height: 22px;
      color: #333;
      margin: 0;
      text-align: left;
    }
    .home-center-news{
      padding:0 !important;
    }
    .home-news-ul li{
      width: 100%;
      float: left;
      padding: 10px 10px;
      background: #FFFFFF;
      text-align: center;
      position: relative;
      overflow: hidden;
      margin-top: 1px;
    }
    .home-news-title{
      width: 100%;
      float: left;
      margin-top: 5px;
      font-size: 16px;
      line-height: 26px;
      position: relative;
      z-index: 3;
    }
    .home-news-p{
      width: 100%;
      float: left;
      margin-top: 3px;
      font-size: 14px;
      color: #898989;
      line-height: 20px;
      position: relative;
      z-index: 3;
    }
    .companyNews-first{
      font-size: 15px;
      line-height: 20px;
    }
    .video-meun a{
      font-size: 12px;
      padding: 0 10px;
      border-radius: 5px;
      line-height: 25px;
    }

    .companyNew-ul li{
      line-height: 35px;
      font-size: 14px;
      min-height: 0;
    }
    .companyNew-date{
      font-size: 11px;
      line-height: 35px;
    }
    .newsClassName-jydt{
      font-size: 16px;
    }
    .tradingNews-title{
      font-size: 14px;
    }
    .tradingNews-content{
      font-size: 13px;
    }
    .mobule-padding{
      padding: 0 !important;
      margin-bottom: 15px;
    }
  }
.companyNew-right-ul{
  padding: 0;
  margin: 0;
}
  .companyNew-right-ul li{
    line-height: 40px;
    text-align: left;
    font-size: 16px;
    padding-left: 12px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .companyNews-right-img{
    height: 110px;
    padding-top: 6%;
    object-fit: cover;
    width: 100%;
  }

</style>




// WEBPACK FOOTER //
// src/views/Home_en.vue